<template>
  <div class="expande-horizontal column pt-0">
    <v-flex xs12>
      <div class="windows-style expande-horizontal fonte column">
        <transition name="slide-fade">
          <v-list-item class="pa-0 ma-0">
            <v-avatar
              @click="backToList"
              style="cursor: pointer;"
              size="27"
              :color="$theme.primary"
              class="mr-2"
              icon
            >
              <v-icon color="#f2f2f2">mdi-close</v-icon>
            </v-avatar>
            <v-list-item-content>
              <v-list-item-title class="font-weight-bold">
                {{ get_veiculo.new ? "Novo veículo" : get_veiculo.placa }}
              </v-list-item-title>
              <v-list-item-subtitle class="font-mini">
                Gerencie os detalhes abaixo
              </v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </transition>
      </div>
    </v-flex>

    <div
      style="min-height: 80vh; max-height: 80vh;"
      class="windows-style-content expande-horizontal wrap"
    >
      <v-flex xs12>
        <v-form ref="form">
          <div class="expande-horizontal wrap pt-3">
            <v-flex class="px-2" xs12 md6>
              <v-text-field
                v-model="get_veiculo.placa"
                filled
                label="Placa"
                clearable
                :color="$theme.primary"
                :rules="[v => !!v || 'Preencha este campo']"
                placeholder="ex: ABC1D23"
              ></v-text-field>
            </v-flex>
            <v-flex class="px-2" xs12 md6>
              <v-text-field
                v-model="get_veiculo.modelo"
                filled
                label="Modelo"
                clearable
                :color="$theme.primary"
                placeholder="ex: Fiorino"
              ></v-text-field>
            </v-flex>
          </div>

          <div class="expande-horizontal wrap">
            <v-flex class="px-2" xs12 md6>
              <v-text-field
                v-model="get_veiculo.capacidade"
                filled
                label="Capacidade"
                clearable
                :color="$theme.primary"
                placeholder="ex: 600 kg"
              ></v-text-field>
            </v-flex>
            <v-flex class="px-2" xs12 md6>
              <v-autocomplete
                v-model="get_veiculo.unity"
                :items="get_unidades.docs"
                item-text="nome"
                item-value="_id"
                filled
                clearable
                label="Polo"
                placeholder="Selecione um polo"
                :color="$theme.primary"
              ></v-autocomplete>
            </v-flex>
          </div>

          <v-flex class="px-2" xs12>
            <v-switch
              v-model="get_veiculo.ativo"
              inset
              :color="$theme.primary"
              label="Veículo ativo"
            ></v-switch>
          </v-flex>
        </v-form>
      </v-flex>
    </div>

    <div class="expande-horizontal py-1 windows-style-bottom">
      <v-btn large dark @click="valida_form" :color="$theme.primary">
        <span class="fonte">Salvar</span>
      </v-btn>
      <v-btn
        v-if="get_veiculo._id"
        large
        text
        color="red"
        class="ml-2"
        @click="excluir_veiculo(get_veiculo)"
      >
        Remover
      </v-btn>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters(["get_veiculo", "get_unidades"])
  },
  methods: {
    ...mapActions([
      "criar_veiculo",
      "atualizar_veiculo",
      "excluir_veiculo",
      "listar_unidades"
    ]),
    valida_form() {
      if (this.$refs.form.validate()) {
        this.get_veiculo._id ? this.atualizar_veiculo() : this.criar_veiculo();
      }
    },
    backToList() {
      this.$store.commit("set_veiculo", {});
      this.$forceUpdate();
    }
  },
  created() {
    if (!this.get_unidades.docs || !this.get_unidades.docs.length) {
      this.listar_unidades();
    }
  }
};
</script>
